module.exports = __webpack_public_path__ + "img/DE00572.65803569.png";